// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/////////////////////////////////////////////////
///          QA                           //////
////////////////////////////////////////////////
/*
export const environment = {
    production: false,
    apiBasePath: 'https://kcqaapi.kloudconnect.com.au',
    authServerUrl: 'https://login-secure.kloudconnect.com.au',
    apiClientPath: 'https://kcqa.kloudconnect.com.au',
    realm: 'dotnet-ka',
    clientId: 'frontend',
    resourceServerId: 'api',
    dmsBasePath: 'https://kcdms.kloudconnect.com.au/api/'
};*/

/*
/////////////////////////////////////////////////
///          Development                  //////
////////////////////////////////////////////////
export const environment = {
  production: false,
  apiBasePath: 'https://localhost:44351',
  authServerUrl: 'https://login-secure.kloudconnect.com.au',
  apiClientPath: 'http://localhost:4200',
  realm: 'dotnet-ka',
  clientId: 'frontend',
  resourceServerId: 'api',
  dmsBasePath:'https://kcdms.kloudconnect.com.au/api/' //Change the kcdms url as per requirement
};*/

 
/////////////////////////////////////////////////
///          Staging                      //////
////////////////////////////////////////////////
//export const environment = {
//    production: true,
//    apiBasePath: `https://kcdemoapi-keycloak.kloudconnect.com.au`,
//    authServerUrl: `https://qa-secure.kloudconnect.com.au`,
//    apiClientPath: 'https://kcdemo-keycloak.kloudconnect.com.au',
//    realm: 'kcdemo-app',
//    clientId: 'frontend',
//    resourceServerId: 'api',
//    dmsBasePath: 'https://kcdmsstage.kloudconnect.com.au/api/',
//    appInsights: {
//        instrumentationKey: '57201933-75cc-457f-bc68-bbf81f183576'
//    },
//    azureFeatureEndPoint: 'Endpoint=https://kc-appconfig-demo.azconfig.io;Id=44dL;Secret=TiJHRqM+fVhYk1o2ouAOqmO8p6Azh/uSqHXx1Jt2IEQ='
//};

 /*
/////////////////////////////////////////////////
///          Pre-Prod                     //////
////////////////////////////////////////////////
export const environment = {
  production: false,
  apiBasePath: `https://preprod-appapi.kloudconnect.com.au`,
  authServerUrl: `https://secure.kloudconnect.com.au`,
  apiClientPath: 'https://preprod-app.kloudconnect.com.au',
  realm: 'dotnet-ka',
  clientId: 'frontend',
  resourceServerId: 'api',
  dmsBasePath:'https://kcdmsstage.kloudconnect.com.au/api/'
}; 
*/

/////////////////////////////////////////////////////////
////////          Production              ///////////////////
////////////////////////////////////////////////////////


export const environment = {
   production: true,
   apiBasePath: 'https://appapi.kloudconnect.com.au',
   authServerUrl: 'https://secure.kloudconnect.com.au',
   apiClientPath: 'https://app.kloudconnect.com.au',
   realm: 'dotnet-ka',
   clientId: 'frontend',
   resourceServerId: 'api',
   dmsBasePath: 'https://kcdmsapp.kloudconnect.com.au/api/',
   appInsights: {
    instrumentationKey: '789c9374-ac48-40dd-92c1-68f1d134face'
  },
  azureFeatureEndPoint: 'Endpoint=https://kc-appconfig-prod.azconfig.io;Id=3H0Q;Secret=Acy8hSDkzXP4F18pVp7F6JBmbmAPFFMulELlvDFeUt4=',
  syncfusionLicenseKey: "Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXtcc3RcRmRfV0VzX0tWYEo="
};